 import React, { useState, useRef, useEffect } from "react";
import "./SecondNavbar.css";
import { NavLink } from "react-router-dom";
import { FaBars } from "react-icons/fa";

function SecondNavbar() {
  const [showDropdown, setShowDropdown] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const dropdownRef = useRef(null);

  const closeMenu = () => {
    setMobileOpen(false);
    setShowDropdown(false);
  }

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="second-navbar">
      <div className="second-hamburger" onClick={() => setMobileOpen(!mobileOpen)}>
        <FaBars /> Menu
      </div>

      <ul className={mobileOpen ? "active" : ""}>
        <li
          ref={dropdownRef}
          className={`dropdown ${showDropdown ? 'active' : ''}`}
          onMouseEnter={() => window.innerWidth > 768 && setShowDropdown(true)} 
          onMouseLeave={() => window.innerWidth > 768 && setShowDropdown(false)} 
        >
          <NavLink 
            to="/Awareness" 
            onClick={(e) => {
              e.preventDefault(); 
              setShowDropdown(!showDropdown) 
            }}
          >
            Awareness
          </NavLink>
          
          <ul className="dropdown-menu">
            <li><NavLink to="/Awareness/air" onClick={closeMenu}>Air</NavLink></li>
            <li><NavLink to="/Awareness/water" onClick={closeMenu}>Water</NavLink></li>
            <li><NavLink to="/Awareness/plant" onClick={closeMenu}>Plant</NavLink></li>
            <li><NavLink to="/Awareness/land" onClick={closeMenu}>Land</NavLink></li>
            <li><NavLink to="/Awareness/Birds" onClick={closeMenu}>Birds</NavLink></li>
            <li><NavLink to="/Awareness/Animal" onClick={closeMenu}>Animal</NavLink></li>
            <li><NavLink to="/Awareness/Sunlight" onClick={closeMenu}>SunLight</NavLink></li>
          </ul>
        </li>

        <li><NavLink to="/Report" onClick={closeMenu}>Report</NavLink></li>
        
        <li>
          <NavLink to="/my-reports" onClick={closeMenu}>
            My Reports
          </NavLink>
        </li>

        <li><NavLink to="/Event" onClick={closeMenu}>Event</NavLink></li>
        <li><NavLink to="/Campaign" onClick={closeMenu}>Campaign</NavLink></li>
        <li><NavLink to="/Blog" onClick={closeMenu}>Blog</NavLink></li>
        <li><NavLink to="/Feedback" onClick={closeMenu}>Feedback</NavLink></li>
        <li><NavLink to="/join-as-volunteer" onClick={closeMenu}>Join as Volunteer</NavLink></li>
      </ul>
    </div>
  );
}

export default SecondNavbar;